import script from "./GridView.vue?vue&type=script&setup=true&lang=js"
export * from "./GridView.vue?vue&type=script&setup=true&lang=js"

import "./GridView.vue?vue&type=style&index=0&id=2779885a&lang=css"

const __exports__ = script;

export default __exports__